// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_J-z","hovered":"aK-z","hoverImage":"bK-z","mainImage":"cK-z","imageNoBackground":"dK-z","fullSizeImage":"eK-z"};